export enum SsoIdentifierEnum {
    GOOGLE_SSO = 'GOOGLE_SSO',
    MICROSOFT_SSO = 'MICROSOFT_SSO',
    AUTODESK_SSO = 'AUTODESK_SSO',
}
